'use client';

import { useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { GenderField } from '@/features/tournament-wizard/blocks';
import type { Gender } from '@/types';

interface EditGenderModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentGender: Gender;
  onSave: (newGender: Gender) => Promise<boolean>;
  isLoading: boolean;
}

export function EditGenderModal({
  isOpen,
  onClose,
  currentGender,
  onSave,
  isLoading,
}: EditGenderModalProps) {
  const [gender, setGender] = useState<Gender>(currentGender);

  const handleSave = async () => {
    await onSave(gender);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Género"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <GenderField
          value={gender}
          onChange={setGender}
          wrapInCard={false}
        />
      </div>
    </EditModal>
  );
}
